import resourceConfig from '../config';

export default {
  resources: {
    [resourceConfig.name]: {
      name: 'ERP коды',
      fields: {
        docErpHId: 'ERP Документ',
        algorithm: 'Алгоритм поиска',
        ki: 'Код идентификации',
        num_goods: 'Код товара',
        uit_code: 'КМ',
        uitu_code: 'SSCC',
        full_km: 'Полный КМ',
        cashierError: 'Ошибка проверки кассы',
        cashierReqId: 'ID запроса ТС ПИоТ',
        cashierReqTimestamp: 'Время запроса ТС ПИоТ',
        cashierErrorCode: 'Код ошибки проверки кассы',
        canBeSold: 'Продажа разрешена',
        isCheckedOffline: 'Офлайн-проверка',
        tspiotInst: 'Экземпляр ЛМ ЧЗ',
        tspiotVersion: 'Версия базы ЛМ ЧЗ',
      },
    }
  }
}
